import { jsx } from '@emotion/react';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
export const shouldRender = (data) => {
    const { isEnterpriseAccount, enterpriseTrialEndDate } = data.currentAccount;
    if (!enterpriseTrialEndDate || isEnterpriseAccount)
        return false;
    const enterpriseTrialHasEnded = parseDateTime(enterpriseTrialEndDate) < new Date();
    return enterpriseTrialHasEnded && daysFromNow(enterpriseTrialEndDate) <= 7;
};
export const Component = function EnterpriseTrialEnded(props) {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const onContactSalesClick = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'enterprise_trial_ended_banner_cta_clicked',
            interaction_goal: 'contact_sales',
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    return (jsx(Alert, { variant: props.variant, title: "Your Enterprise trial has ended", status: "info" },
        jsx(Link, { href: getFullyQualifiedURL('/l/contact-sales?demo_source=enterprise-trial-ended-banner-logged-in'), onClick: onContactSalesClick }, "Contact Sales"),
        ' ',
        "to keep using our advanced administrative and security controls."));
};
//# sourceMappingURL=EnterpriseTrialEnded.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
